module.exports = __webpack_public_path__ + "assets/622560e0aab4e5172559caf6efff54b0.mp3";